import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { userApiUrl, isLocalEnv } from 'services/api/apiConfig'
import { users } from 'mock/users'

const MAX_EMULATE_USERS = 10

function normalizeEmulateUser(candidate) {
  const firstName = candidate?.firstName ?? candidate?.first_name ?? ''
  const lastName = candidate?.lastName ?? candidate?.last_name ?? ''
  const email = candidate?.email ?? ''
  const displayName = `${firstName} ${lastName}`.trim()

  return {
    ...candidate,
    id: candidate?.id ?? email,
    firstName,
    lastName,
    email,
    name: candidate?.name ?? (displayName && email ? `${displayName} (${email})` : displayName || email),
  }
}

function normalizeEmulateUsers(response) {
  const userList = Array.isArray(response)
    ? response
    : Array.isArray(response?.users)
      ? response.users
      : Array.isArray(response?.data)
        ? response.data
        : []

  return userList
    .map(normalizeEmulateUser)
    .filter(user => user.email || user.name)
}

/**
 * Gets the list of available user roles
 * @returns {Promise<any>}
 */
export const getUserRoles = async () => {
  return new Promise((resolve, reject) => {
    callApi(`${userApiUrl}/user/roles`, 'GET', null, false)
      .then(response => {
        // @ts-ignore
        resolve(response)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting user roles')
        console.log(error)
        reject(error)
      })
  })
}

export const getEmulateUsers = async query => {
  const lowerCaseQuery = String(query ?? '').toLowerCase().trim()

  try {
    const response = await callApi(`${userApiUrl}/user/getemulateusers?application=bm&searchTerm=${encodeURIComponent(lowerCaseQuery)}`, 'GET', null, false)
    return normalizeEmulateUsers(response).slice(0, MAX_EMULATE_USERS)
  } catch (error) {
    if (isLocalEnv) {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Mocked data', 'We are mocking data for getEmulateUsers')
      return normalizeEmulateUsers(users).slice(0, MAX_EMULATE_USERS)
    }

    console.error(error)
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting users to emulate')
    throw error
  }
}
